"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDeclStylable = void 0;
const deprecation_1 = require("../helpers/deprecation");
const postcss_1 = require("postcss");
/**
 * mark extended fields as deprecated.
 * `valueOnThis` is used because postcss.clone copies own properties.
 */
(0, deprecation_1.setFieldForDeprecation)(postcss_1.Rule.prototype, `selectorAst`, {
    objectType: `SRule`,
    valueOnThis: true,
});
(0, deprecation_1.setFieldForDeprecation)(postcss_1.Rule.prototype, `isSimpleSelector`, {
    objectType: `SRule`,
    valueOnThis: true,
});
(0, deprecation_1.setFieldForDeprecation)(postcss_1.Rule.prototype, `selectorType`, {
    objectType: `SRule`,
    valueOnThis: true,
});
(0, deprecation_1.setFieldForDeprecation)(postcss_1.Rule.prototype, `mixins`, {
    objectType: `SRule`,
    valueOnThis: true,
});
(0, deprecation_1.setFieldForDeprecation)(postcss_1.Rule.prototype, `stScopeSelector`, {
    objectType: `SRule`,
    valueOnThis: true,
    pleaseUse: `getRuleScopeSelector(rule)`,
});
(0, deprecation_1.setFieldForDeprecation)(postcss_1.Declaration.prototype, `stylable`, {
    objectType: `SDecl`,
    valueOnThis: true,
    // pleaseUse, // not sure we will support an alternative without a real use case found
});
/**
 * helpers?
 */
function getDeclStylable(decl) {
    if (decl.stylable) {
        return decl.stylable;
    }
    else {
        decl.stylable = decl.stylable ? decl.stylable : { sourceValue: '' };
        return decl.stylable;
    }
}
exports.getDeclStylable = getDeclStylable;
//# sourceMappingURL=postcss-ast-extension.js.map